/** Стоп-слова и ранжирование локального поиска (согласовано с backend support_knowledge_query.py). */

export const SEARCH_STOPWORDS = new Set([
  'как',
  'что',
  'где',
  'когда',
  'кто',
  'чем',
  'чего',
  'какой',
  'какая',
  'какие',
  'какое',
  'какую',
  'каком',
  'каким',
  'это',
  'этот',
  'эта',
  'эти',
  'этого',
  'этой',
  'тот',
  'та',
  'те',
  'для',
  'при',
  'над',
  'под',
  'без',
  'про',
  'или',
  'ли',
  'не',
  'ни',
  'на',
  'по',
  'из',
  'от',
  'до',
  'за',
  'об',
  'во',
  'со',
  'бы',
  'же',
  'the',
  'a',
  'an',
  'is',
  'are',
  'to',
  'in',
  'on',
  'for',
  'and',
  'or',
])

export function meaningfulSearchTokens(query: string): string[] {
  const tokens = query
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .map((t) => t.replace(/[^\w\u0400-\u04FF-]/g, ''))
    .filter((t) => t.length >= 2)
  const meaningful = tokens.filter((t) => !SEARCH_STOPWORDS.has(t) && t.length >= 3)
  if (meaningful.length > 0) return meaningful
  return tokens.filter((t) => !SEARCH_STOPWORDS.has(t))
}

export function snippetAnchorTokens(query: string): string[] {
  const q = query.trim().toLowerCase()
  const anchors: string[] = []
  if (q.length >= 4) anchors.push(q)
  for (const token of meaningfulSearchTokens(q)) {
    if (!anchors.includes(token)) anchors.push(token)
  }
  return anchors
}

export function scoreLocalSearchMatch(title: string, body: string, tags: string, query: string): number {
  const q = query.trim().toLowerCase()
  if (q.length < 2) return 0

  const hay = `${title}\n${body}\n${tags}`.toLowerCase()
  const titleL = title.toLowerCase()

  if (q.length >= 4 && hay.includes(q)) return 0.98
  if (q.length >= 4 && titleL.includes(q)) return 0.94

  const meaningful = meaningfulSearchTokens(q)
  if (meaningful.length === 0) {
    if (q.length >= 4 && hay.includes(q)) return 0.75
    return 0
  }

  const hits = meaningful.filter((t) => hay.includes(t))
  const titleHits = meaningful.filter((t) => titleL.includes(t))
  if (hits.length === 0 && titleHits.length === 0) return 0

  const coverage = hits.length / meaningful.length
  if (meaningful.length > 1 && coverage < 0.5) return 0

  let score = 0.42 + coverage * 0.4
  if (meaningful.every((t) => hay.includes(t))) score += 0.18
  if (titleHits.length > 0) score += 0.12
  if (meaningful.some((t) => t.startsWith('ответ') || t.includes('ответ'))) {
    if (hay.includes('ответ') || hay.includes('reply') || hay.includes('шаблон')) score += 0.08
  }
  return Math.min(score, 0.97)
}

export function extractHighlightTerms(query: string): string[] {
  const q = query.trim()
  if (!q) return []
  const terms = new Set<string>()
  if (q.length >= 4) terms.add(q)
  for (const token of meaningfulSearchTokens(q)) {
    terms.add(token)
  }
  if (terms.size === 0) {
    for (const token of q.split(/\s+/).filter((t) => t.length >= 3)) {
      terms.add(token)
    }
  }
  return [...terms].sort((a, b) => b.length - a.length)
}
